import { Store } from '@ngrx/store';
import { Component, input, Output, EventEmitter, model, computed } from '@angular/core';
import { selectTransitStatuses, selectVesselVisits, VesselTransitStatus } from '@pmis3/vessel-activity-core';
import { CommonModule } from '@angular/common';
import { IVesselVisit } from '@pmis3/vessel-activity-core';
import { VesselActivityHelper } from '@pmis3/vessel-activity-core';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";

@Component({
    selector: 'pmis3-vessel-visit-detail-movement-authority-status',
    standalone: true,
    imports: [
        CommonModule, 
        KENDO_BUTTONS,
        KENDO_DROPDOWNS
    ],
    templateUrl: 'vessel-visit-detail-movement-authority-status.component.html',
})
export class VesselVisitDetailMovementAuthorityStatusComponent {
    statuses = this.store.selectSignal(selectTransitStatuses);
    statusId = input.required<number | undefined>();
    status = computed(() => this.statuses().find(status => status.id == this.statusId()));

    authorityName = input.required<string>();

    constructor(private store: Store<any>) {}

    statusColour(): string {
        const status = this.status();
        return VesselActivityHelper.getStatusBgColour(status?.name);
    }
}